// Begin ISH Free Shipping and Tumbler Custom Widgets - Dynamic Update

document.addEventListener('ajaxProduct:added', function(evt) {
  console.log("Updating: Product added", evt.detail)
  setTimeout(function(){
    updateFreeShippingWidget();
    updateFreeTumblerWidget();
    updateFreeChocolateWidget();
    updateFreeBookWidget();
  }, 500)
  analyticsEvent(evt.detail.product);
});

document.addEventListener('cart:updated', function(evt) {
  console.log("Updating: Cart added", evt.detail)
  setTimeout(function(){
    updateFreeShippingWidget();
    updateFreeTumblerWidget();
    updateFreeChocolateWidget();
    updateFreeBookWidget();
  }, 500)
});

function updateFreeShippingWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 10000){
        // Add more for free shipping:
        progressAmount = 10000 - subtotal;
        progressWidth = (10000 - progressAmount) / 100;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE SHIPPING</b>.`;              
      } else {
        // Free shipping achieved!
        progressWidth = 100;
        message = "Your order will ship for FREE!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-shipping .progress-bar");
      const freeShippingTextEls = document.querySelectorAll(".js-free-shipping .js-free-shipping-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeShippingTextEls.length; i++){
        // console.log("Updating text...", message);
        freeShippingTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeTumblerWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;

      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }

      if (subtotal < 10000){
        // Add more for free tumbler:
        progressAmount = 10000 - subtotal;
        progressWidth = (10000 - progressAmount) / 100;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Leftist Tears Tumbler</b>.`;              
      } else {
        // Free tumbler achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Leftist Tears Tumbler!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-tumbler .progress-bar");
      const freeTumblerTextEls = document.querySelectorAll(".js-free-tumbler .js-free-tumbler-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeTumblerTextEls.length; i++){
        // console.log("Updating text...", message);
        freeTumblerTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeChocolateWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 6000){
        // Add more for free chocolate:
        progressAmount = 6000 - subtotal;
        progressWidth = (6000 - progressAmount) / 60;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE 12-Pack Chocolate Box</b>.`;              
      } else {
        // Free Chocolate achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Chocolate 12-Pack!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-chocolate .progress-bar");
      const freeChocolateTextEls = document.querySelectorAll(".js-free-chocolate .js-free-chocolate-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeChocolateTextEls.length; i++){
        // console.log("Updating text...", message);
        freeChocolateTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeBookWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;

      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }

      if (subtotal < 7500){
        // Add more for free book:
        progressAmount = 7500 - subtotal;
        progressWidth = (7500 - progressAmount) / 75;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Johnny The Walrus Book</b>.`;              
      } else {
        // Free book achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Johnny The Walrus Book!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-book .progress-bar");
      const freeTumblerTextEls = document.querySelectorAll(".js-free-book .js-free-book-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeTumblerTextEls.length; i++){
        // console.log("Updating text...", message);
        freeTumblerTextEls[i].innerHTML = message;
      }
    });
}

setTimeout(function(){
  console.log("Updating Progress Widgets")
  updateFreeShippingWidget();
  updateFreeTumblerWidget();
  updateFreeChocolateWidget();
  updateFreeBookWidget();
}, 3000)

// End ISH Free Shipping and Tumbler Custom Widgets - Dynamic Update

// ISH Analytics - Product Added

function analyticsEvent(product){

  let price_in_dollars = product.price / 100;
  
  if (typeof analytics == "object"){
    // console.log("Product Added", product);
    analytics.track('Product Added', {
        product_id: product.product_id,
        sku: product.sku,
        name: product.title,
        price: price_in_dollars,
        quantity: product.quantity,
        category: product.product_type
    });
    
    // analytics.identify({
    //   email: checkout.email
    // });
  }
}

// END ISH Analytics - Product Added

// ISH back-forward cache issue fix: Cart Drawer update if page swiped back  
// Works for Android and non-Safari browsers
	
if (!!window.performance && window.performance.navigation.type === 2) {
  // Page was loaded from history (back button or swipe). 
  console.log("Page loaded from history (back button/swipe), refreshing cart...")

  // Refresh cart drawer:
  document.dispatchEvent(new CustomEvent('cart:build'));
}

// END ISH back-forward cache issue fix: Cart Drawer update if page swiped back

// ISH Enable play controls on product videos

const productVideos = document.querySelectorAll(".product__video");
for (let i=0; i < productVideos.length; i++){
  productVideos[i].controls = true;
}

// END ISH Enable play controls on product videos

// ISH Konami Code Easter Egg

var listeningKeys = {
  32: "space",
  37: "left",
  38: "up",
  39: "right",
  40: "down",
  65: "a",
  66: "b"
};

var konamiCodeSequence = [
  "up",
  "up",
  "down",
  "down",
  "left",
  "right",
  "left",
  "right",
  "b",
  "a",
  "space"
];

konamiCodePosition = 0;

document.addEventListener("keydown", function(event){
  let key = listeningKeys[event.keyCode];
  let requiredKey = konamiCodeSequence[konamiCodePosition];
  if (key == requiredKey){
    console.log("========== key pressed ===============", key);
    konamiCodePosition++;

    if (konamiCodePosition == konamiCodeSequence.length){
      console.log("=============== Achievement Unlocked! ===============", "loading...");
      window.location = "https://store.dailywire.com/pages/achievement-unlocked";
    }
  } else {
    // Didn't press the next key in the sequence, reset code:
    konamiCodePosition = 0;
  }
})

// END ISH Konami Code Easter Egg

// ISH Open External Links in new Tab

let links = document.links;
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
  }
}

// END ISH Open External Links in new Tab